import { all, takeLatest } from 'redux-saga/effects';
import { toast } from 'view/common/Toast/saga';
import { fetchProjectsSaga } from 'view/duck/saga';
import types from '../view/duck/types';

export default function* rootSaga() {
  yield all([
    takeLatest('TOAST', toast),
    takeLatest(types.GET_PROJECTS_REQUEST, fetchProjectsSaga),
  ]);
}



// WEBPACK FOOTER //
// ./src/saga/index.js